import { createAsyncThunk } from "@reduxjs/toolkit";

import { getPermisos } from "api/permisos";
import { SLICE_NAMES } from "store/constant";

export const getPermisosThunk = createAsyncThunk(`${SLICE_NAMES.EVALUACIONES}/getPermisos`, async () => {
	const response = await getPermisos();
	return response.data;
});
